export const base = {
  _style: 'style',
  _bkStyle: 'bkStyle',
  _template: 'template',
  _snippet: 'snippet',
  _libs: 'libs',
  _data: 'data',
  _script: 'script',
  _settings: 'settings',
  _interactions: 'interactions',
  _actions: 'actions',
  _actionsStyle: 'actions-style',
  _templateChildHtml: 'template-child-html',
  _templateChildBkHtml: 'template-child-bkhtml',
  _editor: 'editor',
  _styleColumn: 'style-column',
};

export const elementTypes = {
  _elementStyleContainer: 'element-style-container',
  _styleElement: 'style-element',
  _bkStyleElement: 'bkStyle-element',
};

export const moduleTypes = {
  _moduleStyleContainer: 'module-style-container',
  _moduleScriptContainer: 'module-script-container',
  _styleModule: 'style-module',
  _bkStyleModule: 'bkStyle-module',
};

export const rowTypes = {
  _rowStyleContainer: 'row-style-container',
  _columnStyleContainer: 'column-style-container',
  _styleRow: 'style-row',
  _styleColumn: 'style-column',
  _bkStyleRow: 'bkStyle-row',
  _bkStyleColumn: 'bkStyle-column',
};

export const SCROLL_VIEW_KEY = ['scroll-into-view', 'scrolling-in-view'];

export const SHOP_LOCALE_URL = "{{ shop.url }}{{ routes.root_url | split: '/' | join: '/' }}";
